import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

export type WizardPageAction =
    | 'next'
    | 'submit'
    | 'collect-details'
    | 'back'
    | 'sign'
    | 'submit-coapplicant'
    | 'collect-norskgjeld'
    | 'collect-eskat-kreditstatus'
    | 'collect-montio'
    | 'mitid-login'
    | 'redirect'
    | 'consolidation-next'
    | 'continue-with-coapplicant'
    | 'consent';

type WizardState = {
    currentPage: number;
    // Wizard index of the page that collects the current flow's government id -- VerifyIncomePageNO for
    // NO/SE's applicantGovernmentId (LP-2699), or EskatKreditStatusConsentPageDK/
    // CoApplicantEskatKreditStatusConsentPageDK for DK's applicantGovernmentId/coapplicantGovernmentId
    // (LP-2980). Recorded by that page at runtime so the matching SubmitPage can route the user back to it
    // without hard-coding an index. Only one such page is ever mounted per wizard session, so a single field
    // is safe to share across all of them.
    governmentIdPageIndex?: number;
};

import { Selector } from 'react-redux';

export const selectCurrentPage: Selector<RootState, number> = createSelector(
    (state: RootState) => state,
    (state) => state.wizard.currentPage,
);

export const selectGovernmentIdPageIndex: Selector<RootState, number | undefined> = createSelector(
    (state: RootState) => state,
    (state) => state.wizard.governmentIdPageIndex,
);

export const initialWizardState: WizardState = {
    currentPage: 0,
};

export const wizardSlice = createSlice({
    name: 'application',
    initialState: initialWizardState,
    reducers: {
        reset: () => initialWizardState,
        setCurrentPage: (state: WizardState, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setGovernmentIdPageIndex: (state: WizardState, action: PayloadAction<number>) => {
            state.governmentIdPageIndex = action.payload;
        },
    },
});

export const { reset, setCurrentPage, setGovernmentIdPageIndex } = wizardSlice.actions;

export default wizardSlice.reducer;
